import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createSlots as _createSlots, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"width":"100%","background":"#fff"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-center pt-1 pb-4"
}
const _hoisted_5 = { style: {"width":"750px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaxFormAddress = _resolveComponent("TaxFormAddress")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_TaxFormFormattedText = _resolveComponent("TaxFormFormattedText")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_textarea_filled = _resolveComponent("v-textarea-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_TaxFormTable = _resolveComponent("TaxFormTable", true)!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables_, (table, ti) => {
      return (_openBlock(), _createElementBlock("div", { key: ti }, [
        (table.style && table.style.display && table.style.display === 'none')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.rows, (row, ri) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass({ 'd-flex': !row.repeat }),
                  key: ri
                }, [
                  (row.repeat)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.repeatMaxCount, (li) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: li,
                            class: "d-flex"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.columns, (col, ci) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "d-flex align-center",
                                key: ri + '-' + li + '-' + ci,
                                style: _normalizeStyle(_ctx.getStyle(col))
                              }, [
                                (
                                        col.component &&
                                        (col.component.includes('address') ||
                                            col.component.includes('financial'))
                                    )
                                  ? (_openBlock(), _createBlock(_component_TaxFormAddress, {
                                      key: 0,
                                      component: col.component,
                                      fieldsChild: _ctx.fieldsChild_,
                                      subtype: col.component.subtype,
                                      colKey: col.key,
                                      isLoaded: _ctx.isLoaded,
                                      isSent: _ctx.isSent,
                                      readOnly: _ctx.readOnly || _ctx.isReadonly(col.key),
                                      millesimInput: _ctx.millesim,
                                      onUpdateSpecManager: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateSpecManager()))
                                    }, null, 8, ["component", "fieldsChild", "subtype", "colKey", "isLoaded", "isSent", "readOnly", "millesimInput"]))
                                  : (_ctx.isFormattedText(col.key))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (!_ctx.fieldsChild_[`${_ctx.getRepeatedKey(col.key, li)}`])
                                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                              key: 0,
                                              indeterminate: "",
                                              color: "primary",
                                              size: "20"
                                            }))
                                          : (_openBlock(), _createBlock(_component_TaxFormFormattedText, {
                                              key: 1,
                                              modelValue: 
                                            _ctx.fieldsChild_[`${_ctx.getRepeatedKey(col.key, li)}`]
                                                .displayValue
                                        ,
                                              "onUpdate:modelValue": ($event: any) => ((
                                            _ctx.fieldsChild_[`${_ctx.getRepeatedKey(col.key, li)}`]
                                                .displayValue
                                        ) = $event),
                                              onUpdateSpecManager: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSpecManager()))
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      ], 64))
                                    : (col.type && col.type === 'title')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _createTextVNode(_toDisplayString(col.value), 1)
                                        ], 64))
                                      : (col.key && _ctx.isLoaded)
                                        ? (_openBlock(), _createBlock(_component_v_row, {
                                            key: 3,
                                            "no-gutters": "",
                                            class: "pt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              (!_ctx.fieldsChild_[`${_ctx.getRepeatedKey(col.key, li)}`])
                                                ? (_openBlock(), _createBlock(_component_v_col, {
                                                    key: 0,
                                                    cols: "12"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_progress_circular, {
                                                        indeterminate: "",
                                                        color: "primary",
                                                        size: "20"
                                                      })
                                                    ]),
                                                    _: 1
                                                  }))
                                                : (_ctx.selectorOfKey(col.key))
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 1,
                                                      cols: "12"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_ctx.isCheckbox(_ctx.selectorOfKey(col.key)))
                                                          ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                                              key: 0,
                                                              readonly: _ctx.isReadonly(col.key),
                                                              modelValue: 
                                                        _ctx.fieldsChild_[
                                                            `${_ctx.getRepeatedKey(col.key, li)}`
                                                        ].displayValue
                                                    ,
                                                              "onUpdate:modelValue": [
                                                                ($event: any) => ((
                                                        _ctx.fieldsChild_[
                                                            `${_ctx.getRepeatedKey(col.key, li)}`
                                                        ].displayValue
                                                    ) = $event),
                                                                _cache[2] || (_cache[2] = ($event: any) => {
                                                        _ctx.updateSpecManager();
                                                        // as a refresh key but very fast ...
                                                        // for example : 2035A:GF is a reactive value, function of 2035A:GG checkbox value, but is not reactive otherwise
                                                        _ctx.dialog2 = true;
                                                        _ctx.dialog2 = false;
                                                        //
                                                    })
                                                              ],
                                                              "true-value": "X",
                                                              "false-value": '',
                                                              "hide-details": "",
                                                              class: "mt-0",
                                                              color: "primary"
                                                            }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue"]))
                                                          : (_openBlock(), _createBlock(_component_v_select_filled, {
                                                              key: 1,
                                                              readonly: _ctx.isReadonly(col.key),
                                                              modelValue: 
                                                        _ctx.fieldsChild_[
                                                            `${_ctx.getRepeatedKey(col.key, li)}`
                                                        ].displayValue
                                                    ,
                                                              "onUpdate:modelValue": [
                                                                ($event: any) => ((
                                                        _ctx.fieldsChild_[
                                                            `${_ctx.getRepeatedKey(col.key, li)}`
                                                        ].displayValue
                                                    ) = $event),
                                                                _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateSpecManager()))
                                                              ],
                                                              items: 
                                                        _ctx.getSelectorValuesFile(
                                                            _ctx.selectorOfKey(col.key),
                                                        )
                                                    ,
                                                              "append-inner-icon": 
                                                        _ctx.fieldsChild_[
                                                            `${_ctx.getRepeatedKey(col.key, li)}`
                                                        ].value
                                                            ? ''
                                                            : undefined
                                                    ,
                                                              "bg-color": 
                                                        _ctx.isUserValue(col.key)
                                                            ? 'blue lighten-5'
                                                            : '#FFF'
                                                    ,
                                                              "hide-details": "",
                                                              class: _normalizeClass({
                                                        'form-field': true,
                                                        'oss-dark': true,
                                                        'focus-form-field': _ctx.isImpactedByRule(
                                                            col.key,
                                                        ),
                                                        'text-truncate': true,
                                                    }),
                                                              clearable: "",
                                                              block: "",
                                                              "onUpdate:focused": ($event: any) => (_ctx.onFocus($event, col.key)),
                                                              onClick: ($event: any) => (_ctx.setFocusedField(col.key)),
                                                              density: "compact",
                                                              "item-title": "text",
                                                              "item-value": "value"
                                                            }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue", "items", "append-inner-icon", "bg-color", "class", "onUpdate:focused", "onClick"]))
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : (_ctx.keyHasTextArea(col.key))
                                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                                        key: 2,
                                                        cols: "12"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_textarea_filled, {
                                                            modelValue: 
                                                    _ctx.fieldsChild_[`${_ctx.getRepeatedKey(col.key, li)}`]
                                                        .displayValue
                                                ,
                                                            "onUpdate:modelValue": [
                                                              ($event: any) => ((
                                                    _ctx.fieldsChild_[`${_ctx.getRepeatedKey(col.key, li)}`]
                                                        .displayValue
                                                ) = $event),
                                                              _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateSpecManager()))
                                                            ],
                                                            readonly: _ctx.isReadonly(col.key),
                                                            "hide-details": "",
                                                            "bg-color": 
                                                    _ctx.isUserValue(col.key) ? 'blue lighten-5' : '#FFF'
                                                ,
                                                            class: _normalizeClass({
                                                    'form-field': true,
                                                    'focus-form-field': _ctx.isImpactedByRule(col.key),
                                                }),
                                                            dense: "",
                                                            block: "",
                                                            onClick: ($event: any) => (_ctx.setFocusedField(col.key))
                                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "bg-color", "class", "onClick"])
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : (_openBlock(), _createBlock(_component_v_col, {
                                                        key: 3,
                                                        cols: "12"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_textarea_filled, {
                                                            maxlength: 200,
                                                            rows: "1",
                                                            "auto-grow": "",
                                                            modelValue: 
                                                    _ctx.fieldsChild_[`${_ctx.getRepeatedKey(col.key, li)}`]
                                                        .displayValue
                                                ,
                                                            "onUpdate:modelValue": [
                                                              ($event: any) => ((
                                                    _ctx.fieldsChild_[`${_ctx.getRepeatedKey(col.key, li)}`]
                                                        .displayValue
                                                ) = $event),
                                                              _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateSpecManager()))
                                                            ],
                                                            readonly: _ctx.isReadonly(col.key),
                                                            "bg-color": 
                                                    _ctx.isUserValue(col.key) ? 'blue lighten-5' : '#FFF'
                                                ,
                                                            "hide-details": "",
                                                            reverse: _ctx.justifyInputRight(col.key),
                                                            class: _normalizeClass({
                                                    'form-field': true,
                                                    'focus-form-field': _ctx.isImpactedByRule(col.key),
                                                }),
                                                            label: _ctx.getKey(`${_ctx.getRepeatedKey(col.key, li)}`),
                                                            "onUpdate:focused": ($event: any) => (_ctx.setFocused($event, col.key)),
                                                            density: "compact",
                                                            onKeydown: _ctx.preventEnter
                                                          }, _createSlots({ _: 2 }, [
                                                            (
                                                        _ctx.rules_[col.key] && _ctx.rules_[col.key].function
                                                    )
                                                              ? {
                                                                  name: "append",
                                                                  fn: _withCtx(() => [
                                                                    (
                                                            _ctx.appendIcon(col.key) && _ctx.rules_[col.key]
                                                        )
                                                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                                          key: 0,
                                                                          location: "bottom"
                                                                        }, {
                                                                          activator: _withCtx(({ props }) => [
                                                                            _createVNode(_component_v_icon, _mergeProps({
                                                                              class: "mt-2",
                                                                              ref_for: true
                                                                            }, props, {
                                                                              onClick: ($event: any) => (
                                                                    _ctx.openFunctionDialog(
                                                                        _ctx.rules_[col.key].function,
                                                                        _ctx.getRepeatedKey(col.key, li),
                                                                        _ctx.fieldsChild_[
                                                                            `${_ctx.getRepeatedKey(
                                                                                col.key,
                                                                                li,
                                                                            )}`
                                                                        ].displayValue,
                                                                        li,
                                                                    )
                                                                ),
                                                                              size: "small"
                                                                            }), {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(_ctx.appendIcon(col.key)), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1040, ["onClick"])
                                                                          ]),
                                                                          default: _withCtx(() => [
                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitFunctionString(
                                                                _ctx.rules_[col.key].function,
                                                            ), (tooltip, ti) => {
                                                                              return (_openBlock(), _createElementBlock("span", { key: ti }, [
                                                                                (ti % 2)
                                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                      _createTextVNode(_toDisplayString(tooltip), 1)
                                                                                    ], 64))
                                                                                  : (_openBlock(), _createBlock(_component_v_chip, {
                                                                                      key: 1,
                                                                                      class: "mx-1",
                                                                                      size: "small"
                                                                                    }, {
                                                                                      default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(tooltip), 1)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024))
                                                                              ]))
                                                                            }), 128))
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  key: "0"
                                                                }
                                                              : undefined
                                                          ]), 1032, ["modelValue", "onUpdate:modelValue", "readonly", "bg-color", "reverse", "class", "label", "onUpdate:focused", "onKeydown"])
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (col.tables)
                                          ? (_openBlock(), _createBlock(_component_TaxFormTable, {
                                              key: 4,
                                              tables: col.tables,
                                              values: _ctx.values_,
                                              isLoaded: _ctx.isLoaded,
                                              fieldsChild: _ctx.fieldsChild_,
                                              rules: _ctx.rules_,
                                              sheet: _ctx.sheet,
                                              isSent: _ctx.isSent,
                                              readonly: _ctx.readOnly,
                                              millesimInput: _ctx.millesim,
                                              onUpdateSpecManager: _ctx.updateSpecManager,
                                              onAdditionnalPageCreated: _ctx.additionnalPageCreated
                                            }, null, 8, ["tables", "values", "isLoaded", "fieldsChild", "rules", "sheet", "isSent", "readonly", "millesimInput", "onUpdateSpecManager", "onAdditionnalPageCreated"]))
                                          : _createCommentVNode("", true)
                              ], 4))
                            }), 128))
                          ]))
                        }), 128)),
                        (row.link)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createVNode(_component_v_btn, {
                                disabled: _ctx.isSent || _ctx.readOnly,
                                rounded: "",
                                elevation: "0",
                                size: "small",
                                onClick: ($event: any) => (_ctx.createAdditionalPage(row.link))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                                      _createTextVNode("$add")
                                    ])),
                                    _: 1
                                  }),
                                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "pl-1" }, "Ajouter une page complémentaire", -1))
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(row.columns, (col, ci) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "d-flex align-center",
                          key: ri + '-' + ci,
                          style: _normalizeStyle(_ctx.getStyle(col))
                        }, [
                          (
                                    col.component &&
                                    (col.component.includes('address') ||
                                        col.component.includes('financial'))
                                )
                            ? (_openBlock(), _createBlock(_component_TaxFormAddress, {
                                key: 0,
                                component: col.component,
                                fieldsChild: _ctx.fieldsChild_,
                                subtype: col.component.subtype,
                                colKey: col.key,
                                isLoaded: _ctx.isLoaded,
                                isSent: _ctx.isSent,
                                readOnly: _ctx.readOnly || _ctx.isReadonly(col.key),
                                millesimInput: _ctx.millesim,
                                onUpdateSpecManager: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateSpecManager()))
                              }, null, 8, ["component", "fieldsChild", "subtype", "colKey", "isLoaded", "isSent", "readOnly", "millesimInput"]))
                            : (_ctx.isFormattedText(col.key))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (!_ctx.fieldsChild_[col.key])
                                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                        key: 0,
                                        indeterminate: "",
                                        color: "primary",
                                        size: "20"
                                      }))
                                    : (_openBlock(), _createBlock(_component_TaxFormFormattedText, {
                                        key: 1,
                                        modelValue: _ctx.fieldsChild_[`${col.key}`].displayValue,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.fieldsChild_[`${col.key}`].displayValue) = $event),
                                        onUpdateSpecManager: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateSpecManager()))
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                ], 64))
                              : (col.type && col.type === 'title')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(col.value) + " ", 1),
                                    (col.link)
                                      ? (_openBlock(), _createBlock(_component_v_spacer, { key: 0 }))
                                      : _createCommentVNode("", true),
                                    (col.link)
                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                          key: 1,
                                          disabled: _ctx.isSent || _ctx.readOnly,
                                          class: "ml-5",
                                          rounded: "",
                                          elevation: "0",
                                          size: "x-small",
                                          onClick: ($event: any) => (_ctx.createAdditionalPage(col.link))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { size: "x-small" }, {
                                              default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                _createTextVNode("$add")
                                              ])),
                                              _: 1
                                            }),
                                            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "pl-1" }, "Détail", -1))
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "onClick"]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (col.key && _ctx.isLoaded)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 3,
                                      "no-gutters": "",
                                      class: "pt-2"
                                    }, {
                                      default: _withCtx(() => [
                                        (!_ctx.fieldsChild_[col.key])
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              cols: "12"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_progress_circular, {
                                                  indeterminate: "",
                                                  color: "primary",
                                                  size: "20"
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : (_ctx.selectorOfKey(col.key))
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 1,
                                                cols: "12",
                                                style: {"overflow":"hidden"}
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.isCheckbox(_ctx.selectorOfKey(col.key)))
                                                    ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                                        key: 0,
                                                        readonly: _ctx.isReadonly(col.key),
                                                        modelValue: _ctx.fieldsChild_[col.key].displayValue,
                                                        "onUpdate:modelValue": [
                                                          ($event: any) => ((_ctx.fieldsChild_[col.key].displayValue) = $event),
                                                          _cache[8] || (_cache[8] = ($event: any) => {
                                                    _ctx.updateSpecManager();
                                                    // as a refresh key but very fast ...
                                                    // for example : 2035A:GF is a reactive value, function of 2035A:GG checkbox value, but is not reactive otherwise
                                                    _ctx.dialog2 = true;
                                                    _ctx.dialog2 = false;
                                                    //
                                                })
                                                        ],
                                                        "true-value": "X",
                                                        "false-value": '',
                                                        "hide-details": "",
                                                        class: "mt-0",
                                                        color: "primary"
                                                      }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue"]))
                                                    : (_openBlock(), _createBlock(_component_v_select_filled, {
                                                        key: 1,
                                                        readonly: _ctx.isReadonly(col.key),
                                                        modelValue: _ctx.fieldsChild_[col.key].displayValue,
                                                        "onUpdate:modelValue": [
                                                          ($event: any) => ((_ctx.fieldsChild_[col.key].displayValue) = $event),
                                                          _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateSpecManager()))
                                                        ],
                                                        items: 
                                                    _ctx.getSelectorValuesFile(_ctx.selectorOfKey(col.key))
                                                ,
                                                        "bg-color": 
                                                    _ctx.isUserValue(col.key) ? 'blue lighten-5' : '#FFF'
                                                ,
                                                        "hide-details": "",
                                                        class: _normalizeClass({
                                                    'form-field': true,
                                                    'oss-dark': true,
                                                    'focus-form-field': _ctx.isImpactedByRule(col.key),
                                                    'text-truncate': true,
                                                }),
                                                        block: "",
                                                        clearable: "",
                                                        "onUpdate:focused": ($event: any) => (_ctx.onFocus($event, col.key)),
                                                        onClick: ($event: any) => (_ctx.setFocusedField(col.key)),
                                                        density: "compact",
                                                        "item-title": "text",
                                                        "item-value": "value"
                                                      }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue", "items", "bg-color", "class", "onUpdate:focused", "onClick"]))
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : (_ctx.keyHasTextArea(col.key))
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 2,
                                                  cols: "12"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_textarea_filled, {
                                                      modelValue: _ctx.fieldsChild_[col.key].displayValue,
                                                      "onUpdate:modelValue": [
                                                        ($event: any) => ((_ctx.fieldsChild_[col.key].displayValue) = $event),
                                                        _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateSpecManager()))
                                                      ],
                                                      "bg-color": 
                                                _ctx.isUserValue(col.key) ? 'blue lighten-5' : '#FFF'
                                            ,
                                                      "hide-details": "",
                                                      class: _normalizeClass({
                                                'form-field': true,
                                                'focus-form-field': _ctx.isImpactedByRule(col.key),
                                            }),
                                                      dense: "",
                                                      block: "",
                                                      onClick: ($event: any) => (_ctx.setFocusedField(col.key))
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "bg-color", "class", "onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : (_ctx.isPercentage(col.key))
                                                ? (_openBlock(), _createBlock(_component_v_col, {
                                                    key: 3,
                                                    cols: "12"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_text_field_filled, {
                                                        readonly: _ctx.isReadonly(col.key),
                                                        modelValue: _ctx.fieldsChild_[col.key].value,
                                                        "onUpdate:modelValue": [
                                                          ($event: any) => ((_ctx.fieldsChild_[col.key].value) = $event),
                                                          _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateSpecManager()))
                                                        ],
                                                        "bg-color": 
                                                _ctx.isUserValue(col.key) ? 'blue lighten-5' : '#FFF'
                                            ,
                                                        dense: "",
                                                        "hide-details": "",
                                                        reverse: _ctx.justifyInputRight(col.key),
                                                        class: _normalizeClass({
                                                'form-field': true,
                                                'oss-dark': true,
                                                'focus-form-field': _ctx.isImpactedByRule(col.key),
                                            }),
                                                        label: _ctx.getKey(col.key),
                                                        "onUpdate:focused": ($event: any) => (_ctx.setFocused($event, col.key))
                                                      }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue", "bg-color", "reverse", "class", "label", "onUpdate:focused"])
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : (_openBlock(), _createBlock(_component_v_col, {
                                                    key: 4,
                                                    cols: "12"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_text_field_filled, {
                                                        readonly: _ctx.isReadonly(col.key),
                                                        modelValue: _ctx.fieldsChild_[col.key].displayValue,
                                                        "onUpdate:modelValue": [
                                                          ($event: any) => ((_ctx.fieldsChild_[col.key].displayValue) = $event),
                                                          _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateSpecManager()))
                                                        ],
                                                        "bg-color": 
                                                _ctx.isUserValue(col.key) ? 'blue lighten-5' : '#FFF'
                                            ,
                                                        dense: "",
                                                        "hide-details": "",
                                                        reverse: _ctx.justifyInputRight(col.key),
                                                        class: _normalizeClass({
                                                'form-field': true,
                                                'focus-form-field': _ctx.isImpactedByRule(col.key),
                                            }),
                                                        label: _ctx.getKey(col.key),
                                                        "onUpdate:focused": ($event: any) => (_ctx.setFocused($event, col.key))
                                                      }, _createSlots({ _: 2 }, [
                                                        (_ctx.rules_[col.key] && _ctx.rules_[col.key].function)
                                                          ? {
                                                              name: "append",
                                                              fn: _withCtx(() => [
                                                                (_ctx.appendIcon(col.key) && _ctx.rules_[col.key])
                                                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                                      key: 0,
                                                                      bottom: ""
                                                                    }, {
                                                                      activator: _withCtx(({ props }) => [
                                                                        _createVNode(_component_v_icon, _mergeProps({
                                                                          class: "mt-2",
                                                                          ref_for: true
                                                                        }, props, {
                                                                          onClick: ($event: any) => (
                                                                _ctx.openFunctionDialog(
                                                                    _ctx.rules_[col.key].function,
                                                                    col.key,
                                                                    _ctx.fieldsChild_[col.key]
                                                                        .displayValue,
                                                                )
                                                            ),
                                                                          size: "small"
                                                                        }), {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.appendIcon(col.key)), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1040, ["onClick"])
                                                                      ]),
                                                                      default: _withCtx(() => [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitFunctionString(
                                                            _ctx.rules_[col.key].function,
                                                        ), (tooltip, ti) => {
                                                                          return (_openBlock(), _createElementBlock("span", { key: ti }, [
                                                                            (ti % 2)
                                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                  _createTextVNode(_toDisplayString(tooltip), 1)
                                                                                ], 64))
                                                                              : (_openBlock(), _createBlock(_component_v_chip, {
                                                                                  key: 1,
                                                                                  class: "mx-1",
                                                                                  size: "small"
                                                                                }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(tooltip), 1)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024))
                                                                          ]))
                                                                        }), 128))
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              key: "0"
                                                            }
                                                          : undefined
                                                      ]), 1032, ["readonly", "modelValue", "onUpdate:modelValue", "bg-color", "reverse", "class", "label", "onUpdate:focused"])
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (col.tables)
                                    ? (_openBlock(), _createBlock(_component_TaxFormTable, {
                                        key: 4,
                                        tables: col.tables,
                                        values: _ctx.values_,
                                        isLoaded: _ctx.isLoaded,
                                        fieldsChild: _ctx.fieldsChild_,
                                        rules: _ctx.rules_,
                                        sheet: _ctx.sheet,
                                        isSent: _ctx.isSent,
                                        readOnly: _ctx.readOnly,
                                        millesimInput: _ctx.millesim,
                                        onUpdateSpecManager: _ctx.updateSpecManager,
                                        onAdditionnalPageCreated: _ctx.additionnalPageCreated
                                      }, null, 8, ["tables", "values", "isLoaded", "fieldsChild", "rules", "sheet", "isSent", "readOnly", "millesimInput", "onUpdateSpecManager", "onAdditionnalPageCreated"]))
                                    : _createCommentVNode("", true)
                        ], 4))
                      }), 128))
                ], 2))
              }), 128))
            ]))
      ]))
    }), 128)),
    (_ctx.functionDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          modelValue: _ctx.functionDialog,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.functionDialog) = $event)),
          title: "Détail du champ sélectionné",
          onClose: _cache[18] || (_cache[18] = ($event: any) => {
                _ctx.functionDialog = false;
                _ctx.radicalTab = 'generalLedger';
            }),
          onValid: _cache[19] || (_cache[19] = ($event: any) => (_ctx.updateResetUserValue())),
          "hide-valid": (_ctx.isRadicalOnly(_ctx.keyManualValue) && !_ctx.enableEdition) || _ctx.isSent || _ctx.readOnly
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.sheet && _ctx.sheet.bundleBase)
                ? (_openBlock(), _createBlock(_component_v_tabs, {
                    key: 0,
                    modelValue: _ctx.radicalTab,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.radicalTab) = $event)),
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.enableEdition || !_ctx.isRadicalOnly(_ctx.keyManualValue))
                        ? (_openBlock(), _createBlock(_component_v_tab, {
                            key: 0,
                            value: "edition",
                            href: "#edition"
                          }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode("Edition")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.containsRadical(_ctx.keyManualValue))
                        ? (_openBlock(), _createBlock(_component_v_tab, {
                            key: 1,
                            value: "generalLedger",
                            href: "#generalLedger"
                          }, {
                            default: _withCtx(() => _cache[26] || (_cache[26] = [
                              _createTextVNode("Comptes de la balance")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.containsRadical(_ctx.keyManualValue))
                        ? (_openBlock(), _createBlock(_component_v_tab, {
                            key: 2,
                            value: "radicals",
                            href: "#radicals"
                          }, {
                            default: _withCtx(() => _cache[27] || (_cache[27] = [
                              _createTextVNode("Fourchettes de comptes")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_tabs_window, {
                modelValue: _ctx.radicalTab,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.radicalTab) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tabs_window_item, { value: "edition" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "px-5 my-3 d-flex justify-center align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                              _createElementVNode("b", null, "Formule :", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "9" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.functionInDialog), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "px-5 my-3 d-flex justify-center align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                              _createElementVNode("b", null, "Valeur d'origine :", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "9" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getOriginalValue()) + " ", 1),
                              _createVNode(_component_v_btn, {
                                disabled: _ctx.isSent || _ctx.readOnly,
                                rounded: "circle",
                                elevation: "0",
                                size: "x-small",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.resetOriginalValue())),
                                icon: "$fa-sync-alt",
                                class: "ml-1"
                              }, null, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "px-5 my-3 d-flex justify-center align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => _cache[30] || (_cache[30] = [
                              _createElementVNode("b", null, "Valeur actuelle :", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "9" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getCurrentValue()), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "px-5 my-3 d-flex justify-center align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => _cache[31] || (_cache[31] = [
                              _createElementVNode("b", null, "Valeur manuelle :", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                disabled: 
                                        (_ctx.isRADResult && !_ctx.enableEdition) || _ctx.isSent || _ctx.readOnly
                                    ,
                                modelValue: _ctx.userValue,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.userValue) = $event)),
                                outlined: "",
                                "hide-details": "",
                                label: !_ctx.isSent && !_ctx.readOnly && 'Valeur manuelle',
                                clearable: "",
                                autofocus: "",
                                density: "compact"
                              }, null, 8, ["disabled", "modelValue", "label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "6" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.sheet && _ctx.sheet.bundleBase)
                    ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                        key: 0,
                        value: "generalLedger"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "mb-3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Ce montant de " + _toDisplayString(_ctx.originalValue) + " € a été calculé depuis la balance et n'est pas modifiable. Il se décompose comme suit : ", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "mb-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                                      _createElementVNode("b", null, "Numéro", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "6" }, {
                                    default: _withCtx(() => _cache[33] || (_cache[33] = [
                                      _createElementVNode("b", null, "Libellé", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "text-right"
                                  }, {
                                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                                      _createElementVNode("b", null, "Débit", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "text-right"
                                  }, {
                                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                                      _createElementVNode("b", null, "Crédit", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRadicalComposition(_ctx.functionInDialog), (acc, index) => {
                                return (_openBlock(), _createBlock(_component_v_row, {
                                  "no-gutters": "",
                                  key: index,
                                  class: "my-1"
                                }, {
                                  default: _withCtx(() => [
                                    (acc.balance !== 0 && acc.balance !== -0)
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 0,
                                          cols: "12"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { cols: "2" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(acc.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, { cols: "6" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(acc.description), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, {
                                                  cols: "2",
                                                  class: "text-right"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(acc.balance > 0
                                                    ? _ctx.commaForDot(Math.abs(acc.balance))
                                                    : ""), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, {
                                                  cols: "2",
                                                  class: "text-right"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(acc.balance < 0
                                                    ? _ctx.commaForDot(Math.abs(acc.balance))
                                                    : ""), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.sheet && _ctx.sheet.bundleBase)
                    ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                        key: 1,
                        value: "radicals"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "mb-3"
                              }, {
                                default: _withCtx(() => _cache[36] || (_cache[36] = [
                                  _createTextVNode(" Cette cellule est composée des racines de comptes suivantes : ")
                                ])),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRadicalList(_ctx.functionInDialog), (acc, index) => {
                                return (_openBlock(), _createBlock(_component_v_row, {
                                  "no-gutters": "",
                                  class: "my-1",
                                  key: index
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(`${acc.account} | ${
                                            acc.debit ? "débit : RAD" + acc.debit : " "
                                        }` + `${acc.credit ? "crédit : RAD" + acc.credit : ""}`), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "hide-valid"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog2,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.dialog2) = $event))
    }, null, 8, ["modelValue"])
  ]))
}